import type { RuntimeEnvironment } from "app/Firebase";

const apiOrigins: Partial<Record<RuntimeEnvironment, string>> = {
  STAGING: "https://jm-api-staging-svti344waa-ts.a.run.app",
  PRODUCTION: "https://api.jobmgr.app",
};

export const getApiUrlForEnvironment = (
  environment: RuntimeEnvironment,
  path: string,
) => {
  const normalisedPath = path.startsWith("/") ? path : `/${path}`;
  return `${apiOrigins[environment] ?? ""}${normalisedPath}`;
};

export const resolveApiUrlForEnvironment = (
  environment: RuntimeEnvironment,
  url: string,
) =>
  url.startsWith("/api/") || url.startsWith("api/")
    ? getApiUrlForEnvironment(environment, url)
    : url;
